import React from "react";
import Profile from "./profile";
import setting from "../../assets/images/profile/setting-big.svg";
import { Form, FormControl, Button } from "react-bootstrap";
import steamicon from "../../assets/images/profile/steam.svg";
import keyicon from "../../assets/images/profile/key.svg";

const Settings = () => {

    return (
        <Profile>
            <div className="settings-page ">

                <div className="page-heading">

                    <h3><img src={setting} alt="" /> Settings</h3>

                </div>

                <div className="settings-content ">

                    <Form>
                        <Form.Label>Steam Trade Link</Form.Label>
                        <div className="form-input">
                            <img src={steamicon} alt="" />
                            <FormControl
                            type="text"
                            autoComplete="new-password"
                            placeholder="https://steamcommunity.com/tradeoffer/new/?partner=252043619&token=NIb4588f3u9iuj38ijfi34ji"
                            />
                            <Button variant="outline-secondary" id="button-addon1">
                            FIND IT
                            </Button>
                        </div>

                        <Form.Label>Steam API Key</Form.Label>
                        <div className="form-input">
                            <img src={keyicon} alt="" />
                            <FormControl
                            type="password"
                            placeholder="*****************"
                            autoComplete="new-password"
                            />
                            <Button variant="outline-secondary" id="button-addon1">
                            GENERATE
                            </Button>
                        </div>

                        <Button className="save-btn">SAVE CHANGES</Button>
                    </Form>

                </div>



            </div>
        </Profile>

    );
};

export default Settings;